// extracted by mini-css-extract-plugin
export var actionButton = "_oi-0";
export var actionMenuContainer = "_oi-i";
export var bubble = "_oi-2";
export var bubbleActionMenu = "_oi-j";
export var bubbleContext = "_oi-6";
export var bubbleItems = "_oi-7";
export var customer = "_oi-3";
export var divider = "_oi-8";
export var fileList = "_oi-9";
export var hiddenComment = "_oi-o";
export var infoAbove = "_oi-a";
export var internal = "_oi-4";
export var lightActionButton = "_oi-1";
export var link = "_oi-b";
export var merchant = "_oi-5";
export var message = "_oi-c";
export var profilePicture = "_oi-e";
export var quillToolbarContainer = "_oi-f";
export var senderDate = "_oi-g";
export var senderDateCustomer = "_oi-h";
export var senderName = "_oi-d";
export var time = "_oi-k";
export var uploadedImage = "_oi-l";
export var username = "_oi-m";
export var xsmall = "_oi-n";